// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M2 5H22V19H2V5ZM4 7V17H20V7H4ZM6 9H18V15H6V9Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-button-filled')
export default class ButtonFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'button-filled',
    }
  }
}
